module.exports = __webpack_public_path__ + "static/media/circle.1d970f48.svg";